import {
	Button,
} from "@mui/material";
import React, { useContext } from "react";
import { FormattedMessage } from "react-intl";
import {
	BusinessDataContext,
	BusinessDataContextValues,
	MultistepContext,
	MultistepContextValues,
} from "../../types/context";
import { findComponentStep } from "../../utils/filter";

export const ForgotPasswordButton = () => {
	const { onChangeStep } = useContext(
		MultistepContext
	) as MultistepContextValues;

	const { selectedFlow } = useContext(
		BusinessDataContext
	) as BusinessDataContextValues;
	const recoverPasswordStep = findComponentStep(
		selectedFlow!,
		"RecoverPassword"
	);

	return (
		<Button
			variant="text"
			onClick={() => onChangeStep(recoverPasswordStep)}
			sx={{
				alignSelf: "flex-end",
				fontWeight: "medium",
				textDecoration: "none",
			}}
		>
			<FormattedMessage
				id="login.forgotPassword"
				defaultMessage="Olvidé mi contraseña"
			/>
		</Button>
	);
};